import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey4, grey5 } from 'approot/shared/styles/colours.style';
import {
  FlexCentreAlign,
  flexCentreAlignCss,
  FlexRightAlign,
  FlexSpaceBetween,
  flexSpaceBetweenCss,
} from 'approot/shared/styles/flex.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { spacing16 } from 'approot/shared/styles/spacing.style';
import { useActivityBuilderFontStyles } from 'approot/activity-builder/theme/activity-builder-theme.style';
import { INPUT_WIDTH_SMALL, equationFieldCss } from './equation-response.style';

type EquationResponseProps = {
  $vertical?: boolean;
};

export const EquationResponse = styled.div<EquationResponseProps>`
  border: 1px solid ${grey4};
  border-radius: ${rem(borderRadius8)};
  max-width: ${rem(200)};
  padding: ${rem(spacing16)};
  margin: 0 auto;
  flex-direction: column;

  ${({ $vertical }) => ($vertical ? flexCentreAlignCss : flexSpaceBetweenCss)}

  ${({ $vertical }) =>
    !$vertical &&
    `
      flex-direction: row;
      max-width: ${rem(477)};
    `}
`;

export const EquationResponseBox = styled(FlexCentreAlign)`
  ${() => useActivityBuilderFontStyles()}
  ${equationFieldCss}
  width: ${rem(INPUT_WIDTH_SMALL)};
`;

export const EquationResponseBoxVertical = styled(FlexRightAlign)`
  ${() => useActivityBuilderFontStyles()}
  ${equationFieldCss}
  width: 100%;
`;

export const EquationResponseAnswer = styled.div`
  ${equationFieldCss}
  width: ${rem(INPUT_WIDTH_SMALL)};
  border: 1px solid ${grey5};
  border-radius: ${rem(borderRadius8)};
`;

export const EquationResponseAnswerVertical = styled.div`
  ${equationFieldCss}
  width: 100%;
  border: 1px solid ${grey5};
  border-radius: ${rem(borderRadius8)};
`;

export const EquationResponseOperator = styled.div`
  ${() => useActivityBuilderFontStyles()}
  margin: 0;
`;

export const EquationResponseOperatorWrapper = styled(FlexSpaceBetween)`
  width: 100%;
`;
